// src/utils.ts
function noop() {}
export { noop };